import {WspAPI} from '@mintdata-wsp/common/controllers/network/extended/WspAPI';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';

export const fetcherSingleton = WindowLocationUtil.getFetcher();
export const API = new WspAPI(fetcherSingleton);

